export const SLUG_TO_CONFIG = {
  'sst-chatbot': {
    placeholderText: 'Eg: How can I apply to the SST?',
    autoSuggestOptions: [
      'How is the campus life at SST?',
      'How can I apply to the SST?',
      'What is the eligibility criteria for SST?',
      'What is the fee structure for the program?',
    ],
    chatbotHeader: 'Scaler AI Counsellor',
    showDescription: true,
    productName: 'School of Technology',
    showRcbOption: false,
    contactEmail: 'admissions_sst@scaler.com',
    disableNudge: true,
  },
  'scaler-chatbot': {
    placeholderText: 'Eg: How can I join a scaler program',
    autoSuggestOptions: [
      'Will I receive a certificate for attending the Masterclass?',
      'Will there be any hands-on activities or live demos during the session?',
      'Is this Masterclass suitable for beginners or advanced professionals?',
    ],
    chatbotHeader: 'Scaler AI Counsellor',
    productName: 'Scaler',
    showRcbOption: true,
  },
};
